import type { Extensions } from '@tiptap/react';

import { QuizService } from '@repo/api/quiz/quizService';
import { ErrorMessageHandler } from '@repo/lib/errorMessageHandler';
import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { TableKit } from '@tiptap/extension-table';
import { toast } from 'sonner';

import { AudioNode, ImageNode, VideoNode } from '@/components/ui/tiptap';
import { SelectMediaNode } from '@/components/ui/tiptap/tiptap-node/select-media-node';
import { getFileUrl } from '@/utils/file';

import { simpleExtensionSet } from '.';

export const quizExtensionSet: Extensions = [
  ...simpleExtensionSet,
  ImageNode,
  AudioNode,
  VideoNode,
  TableKit.configure({
    table: {
      resizable: true,
      lastColumnResizable: false,
    },
  }),
];
export function getQuizExtensionBuilderSet(quizId?: string): Extensions {
  if (!quizId) return [];
  return [
    ...quizExtensionSet,
    SelectMediaNode.configure({
      accept: 'image/*,video/*,audio/*',
      maxSize: 1000000 * 15,
      uploadFileFn: async (file, _options, onRequestResolve) => {
        // Handle file upload
        await QuizService.uploadQuizMedia(quizId, file)
          .then((response) => {
            onRequestResolve(response.data.fileType, {
              src: getFileUrl(response.data.id),
              fileType: response.data.fileType,
              title: response.data.name,
            });
          })
          .catch((error) => {
            const errorHandler = new ErrorMessageHandler(baseErrorMessages);
            const errorMessage = errorHandler.processError(error);
            toast.error(`Bład wystąpienia błędu podczas przesyłania pliku: ${file.name}`, {
              description: errorMessage.detail,
            });
          });
      },
      selectedCallbackFn: async (selected, onRequestResolve) => {
        // Handle selected media
        const selectedFile = selected?.files[0];
        if (!selectedFile) return;
        await QuizService.uploadQuizMedia(quizId, selectedFile.id)
          .then((response) => {
            onRequestResolve(response.data.fileType, {
              src: getFileUrl(response.data.id),
              fileType: response.data.fileType,
              title: response.data.name,
            });
          })
          .catch((error) => {
            const errorHandler = new ErrorMessageHandler(baseErrorMessages);
            const errorMessage = errorHandler.processError(error);
            toast.error(`Bład wystąpienia błędu podczas przesyłania pliku: ${selectedFile.name}`, {
              description: errorMessage.detail,
            });
          });
      },
    }),
  ];
}
